<template>
  <el-pagination
    :current-page="page"
    :page-size="pageSize"
    :page-sizes="pageSizes"
    background
    layout="total, sizes, prev, pager, next, jumper"
    :total="total"
    :hide-on-single-page="total <= 0"
    @size-change="sizeChange"
    @current-change="pageChange"
  />
</template>
<script lang="ts" setup>
import { ElPagination } from 'element-plus'
import { defineProps, defineEmits } from 'vue'
interface Prop {
  page: number
  pageSize: number
  total: number
  pageSizes?: number[]
}
const props = withDefaults(defineProps<Prop>(), {
  page: 1,
  pageSize: 10,
  total: 0,
  pageSizes: () => [10, 20, 50, 100],
})

const emit = defineEmits<{
  (e: 'getList'): void
  (e: 'update:pageSize', size: number): void
  (e: 'update:page', page: number): void
}>()
const sizeChange = (size: number) => {
  emit('update:pageSize', size)
  emit('getList')
}
const pageChange = (page: number) => {
  emit('update:page', page)
  emit('getList')
}
</script>
